import { dark } from './dark';
import { light } from './light';

export const highlighterThemes = { dark, light };
